<template>
	<div class="mx-auto card-login">
		<form>
			<div class="form-group">
				<label for="username">Имя пользователя</label>
				<input class="form-control" type="text" id="username" name="username" v-model="login_data.username">
			</div>
			<div class="form-group">
				<label for="password">Пароль</label>
				<input class="form-control" type="password" id="password" name="password" v-model="login_data.password">
			</div>
		</form>
		<button type="button" class="btn btn-primary" @click="onLogin">Войти</button>
	</div>
</template>

<script>

import EventBus from './EventBus'

export default {
	name: 'Login',
	data () {
    	return {
    		login_data: {
	    		username: '',
    			password: '',
    		}
    	}
    },
    methods: {
    	onLogin: function() {
    		EventBus.$emit('onLogin', this.login_data);
    	}
    }
};
</script>

<style>
	.card-login {
		text-align: left;
		width: 100%;
		max-width: 30%;
	}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue